import BaseSelect from "./base-select";
import {ActionTypeEnum} from "../../base/training-literals";

class VolumeSelect extends BaseSelect {
    modelName;

    constructor(props = {}) {
        super (props);
        this.actionType = ActionTypeEnum.VOLUME_SELECT;
        this.modelName = props.modelName || "";
    }

    get(props = {}) {
        return {
            type: this.actionType,
            modelName: props.modelName || this.modelName,
            timelineMap: props.timelineMap || this.timelineMap,
            duration: props.duration || this.until
        }
    }
}

export default VolumeSelect;